import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

export default function Unauthorized() {
  const navigate  = useNavigate();
  const { user, signOut } = useAuth();

  return (
    <div className="unauth-page">
      <div className="unauth-card">
        <div className="unauth-icon">🚫</div>
        <h1 className="unauth-title">Access Denied</h1>
        <p className="unauth-body">
          {user
            ? `Your account role (${user.role}) does not have permission to access this page.`
            : 'You must be logged in to access this page.'}
        </p>
        <div className="unauth-actions">
          <button className="btn btn--secondary" onClick={() => navigate(-1)}>
            ← Go back
          </button>
          {user ? (
            <button className="btn btn--danger" onClick={signOut}>
              Sign out
            </button>
          ) : (
            <button className="btn btn--primary" onClick={() => navigate('/')}>
              Sign in
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
